var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5715 0C38.1142 0 49.143 10.2991 49.143 22.9703C49.143 35.6149 38.1142 45.914 24.5715 45.914C11.0287 45.914 0 35.6149 0 22.9703C0 10.2991 11.0287 0 24.5715 0ZM21.7728 13.8429C21.251 13.8429 20.7529 13.9536 20.2786 14.1751C19.6856 14.4852 19.2113 14.9724 18.9504 15.5483C18.7844 15.947 18.5235 17.143 18.5235 17.1651C18.2626 18.4719 18.1203 20.5982 18.1203 22.9459C18.1203 25.1851 18.2626 27.2206 18.476 28.5495C18.4998 28.5716 18.7607 30.0556 19.0453 30.565C19.5671 31.4953 20.5869 32.0711 21.6779 32.0711H21.7728C22.4843 32.049 23.9785 31.4731 23.9785 31.451C26.4926 30.4764 31.4496 27.4421 33.4419 25.4266L33.5842 25.2937C33.8451 25.05 34.1771 24.6735 34.2483 24.5849C34.6278 24.1198 34.8175 23.5439 34.8175 22.9703C34.8175 22.3258 34.604 21.7277 34.2008 21.2405C34.106 21.1519 33.7502 20.7754 33.4182 20.4653C31.4733 18.5162 26.3977 15.3268 23.7414 14.3523C23.3382 14.1994 22.3183 13.865 21.7728 13.8429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakes);
export default __webpack_public_path__ + "static/media/takes.00841c82f0b8d38b561d05f8e09a5900.svg";
export { ForwardRef as ReactComponent };